import Vue from 'vue'
import axios from "axios";
import {BASE_URL} from "./global";

export const httpNF = axios.create({
    baseURL: `${BASE_URL}/notafiscal-ws/servico/`
})

// export const apiPortal = axios.create({
//   baseURL: BASE_URL
// })

// export default { httpNF };

Vue.use(
    {
        install(Vue) {
            Vue.prototype.$httpNF = httpNF
        }
    }
)
